/**
 * ActivityLog Page
 * Integrates PlatformServices/ActivityLog component via iframe
 */

import React from 'react';
import ServiceFrame from '../../components/ServiceFrame';
import { SERVICE_PORTS } from '../../utils/constants';

const ActivityLog = () => {
  return (
    <ServiceFrame
      serviceUrl={SERVICE_PORTS.ACTIVITY_LOG?.FRONTEND || 3050}
      serviceName="Activity Log"
    />
  );
};

export default ActivityLog;

